/* Hydrates the related-products section: the recommendations Liquid object
   only performs on the product recommendations route, so the element fetches
   its own section render and swaps the result in. */
(function () {
  class RelatedProducts extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loaded) return;
      const url = this.dataset.url;
      if (!url) return;
      fetch(url)
        .then((res) => res.text())
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const fresh = doc.querySelector('[data-related]');
          if (fresh) {
            this.innerHTML = fresh.innerHTML;
            this.dataset.loaded = 'true';
          }
        })
        .catch(() => {});
    }
  }

  if (!customElements.get('related-products')) {
    customElements.define('related-products', RelatedProducts);
  }
})();
